export default function capitalizeFirstLetter(name) {
  return name[0].toUpperCase().concat(name.slice(1).toLowerCase());
}
